import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import type { Approval } from "../../../api/types/approvalTypes";
import { approvalsGridColumnDefinitions } from "./approvalsGridProvider";

interface Props {
  rows: Approval[];
  loading: boolean;
}

const columnVisibilityModel = {
  status: false,
};

const PendingApprovalsGrid = ({ rows, loading }: Props) => (
  <DataGrid<Approval>
    rows={rows}
    columns={approvalsGridColumnDefinitions}
    loading={loading}
    noRowsText="No approvals"
    columnVisibilityModel={columnVisibilityModel}
    disableColumnPinning
    disableColumnReorder
    disableColumnSorting
    disableMultipleRowSelection
  />
);

export default PendingApprovalsGrid;
